import { columns, writeAccessorKeys } from './constants'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { GetMemberGroupTableData } from '@/modules/manage-member/type'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'

interface MemberGroupListTableProps {
	data: GetMemberGroupTableData[]
	total: number
	isLoading?: boolean
}

export default function MemberGroupListTable({
	data,
	total,
	isLoading,
}: MemberGroupListTableProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_OPERATOR,
	)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<DataTablePaginate
				columns={filteredColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
